var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.work)?_c('div',_vm._l((_vm.work.decisions),function(decision){return _c('div',{key:decision.id},_vm._l((decision.media),function(media){return _c('div',{key:media.id},[_c('a',{attrs:{"target":"_blank","href":media.links.original}},[_vm._v("Скачать "+_vm._s(media.file_name))])])}),0)}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }